import { mockData } from './Mock';
import { AppConfigItem } from '../../models/AppConfig';

// 创建一些示例配置数据
const configItems: AppConfigItem[] = [
  {
    id: '1',
    name: '系统名称',
    key: 'system.name',
    value: '冰墩墩平台',
    description: '平台显示的系统名称'
  },
  {
    id: '2',
    name: '最大上传文件大小',
    key: 'upload.maxFileSize',
    value: '10MB',
    description: '用户上传文件的最大限制'
  },
  {
    id: '3',
    name: '会话超时时间',
    key: 'session.timeout',
    value: '30分钟',
    description: '用户登录会话的超时时间'
  },
  {
    id: '4',
    name: '默认分页大小',
    key: 'pagination.defaultSize',
    value: '20',
    description: '列表页面的默认分页数量'
  },
  {
    id: '5',
    name: '邮件服务器地址',
    key: 'email.smtp.host',
    value: 'smtp.example.com',
    description: '邮件发送服务器地址'
  }
];

// 设置Mock数据
mockData.set("getAllConfigs", configItems);
mockData.set("addConfigItem", 6); // 返回新ID
mockData.set("updateConfigItem", true); // 返回更新成功
mockData.set("deleteConfigItem", true); // 返回删除成功 